import { Tag } from '@servicetitan/design-system';
import { useAbandonedCallsCountQuery } from '..';
import { mainLayoutLocators } from '@locators/main-layout';

const AbandonedCallsBadge = () => {
  const abandonedCallsCountQuery = useAbandonedCallsCountQuery();

  let abandonedCallsBadgeTitle = 'Number of new open abandoned calls';
  let abandonedCallsBadgeText: number | string | undefined =
    abandonedCallsCountQuery.data?.abandonedCallFollowUps?.totalCount ??
    // Fall back to any previous fetch's count. This prevents flickering when
    // we render during a slow load.
    abandonedCallsCountQuery.previousData?.abandonedCallFollowUps?.totalCount;

  if (abandonedCallsCountQuery.error) {
    abandonedCallsBadgeText = '?';
    abandonedCallsBadgeTitle =
      'Error counting number of new open abandoned calls';
  }

  return (
    !!abandonedCallsBadgeText && (
      <Tag
        badge
        compact
        style={{
          marginLeft: 'auto',
        }}
        id={mainLayoutLocators.sidenav.abandonedCallsBadge}
        color='critical'
        title={abandonedCallsBadgeTitle}
      >
        {abandonedCallsBadgeText}
      </Tag>
    )
  );
};

export default AbandonedCallsBadge;
